import {
	useState,
	useEffect,
	cloneElement,
	Children,
	PropsWithChildren,
	isValidElement,
	CSSProperties
} from 'react';
import styles from './TabBar.module.scss';
import { TabBarContext } from './TabBar.context';
import { Tab, TTabProps } from './Tab';
import { TAB_BAR_DIRECTION } from '@types';
import { H4 } from '@components';

interface IBaseProps {
	activeTab?: number;
	onChange?: (tabIndex: number) => void;
	removeBottomPadding?: boolean;
	dir?: TAB_BAR_DIRECTION;
}

interface IVertProps extends IBaseProps {
	dir?: TAB_BAR_DIRECTION.VERTICAL;
	width?: number;
	title?: string;
}

interface IHorzProps extends IBaseProps {
	dir?: TAB_BAR_DIRECTION.HORIZONTAL;
	width?: never;
	title?: never;
}

type TProps = IVertProps | IHorzProps;

const TabBarParent = (props: PropsWithChildren<TProps>) => {
	const {
		activeTab = 0,
		onChange,
		removeBottomPadding,
		dir = TAB_BAR_DIRECTION.HORIZONTAL,
		width = 240,
		title = '',
		children
	} = props;
	const [ActiveTab, setActiveTab] = useState(activeTab);

	const setStyle = () => {
		const styles: CSSProperties = {};
		if (dir === TAB_BAR_DIRECTION.VERTICAL) styles.width = `${width}px`;
		return styles;
	}

	useEffect(() => {
		setActiveTab(activeTab);
	}, [activeTab]);

	return (
		<TabBarContext.Provider value={{
			activeTab: ActiveTab,
			onChange,
			setActiveTab
		}}>
			<div className={`${styles.container} ${!removeBottomPadding ? styles.bottomPad : ''} ${dir === TAB_BAR_DIRECTION.VERTICAL ? styles.vertical : ''}`} style={setStyle()}>
				{dir === TAB_BAR_DIRECTION.VERTICAL && title !== '' && <div className={styles.title}><H4>{title}</H4></div>}
				{Children.toArray(children).map((child, index) => {
					if (isValidElement<TTabProps>(child)) {
						return cloneElement(child, { index });
					}
					return child;
				})}
			</div>
		</TabBarContext.Provider>
	);
}

TabBarParent.Tab = Tab;
export const TabBar = TabBarParent
